import {EAIClient} from "Services/EAIClient";
import {observable, flow, makeObservable} from "mobx";
import {appStore} from "Stores/index";

export interface History {
    id: number
    change_date: Date
    field: string
    change: string
    readable_change: string
    changer: string
}

export class HistoryStore {
    client = new EAIClient();

    @observable history: History[] = [];
    @observable currentActionPlan: string | undefined = undefined;
    @observable isFetchingHistory = false;

    constructor() {
        makeObservable(this);
    }

    @flow
    * getAllHistoryForActionPlan(actionPlanId: string): any {
        this.isFetchingHistory = true;
        try {
            const resp = yield this.client.getAllHistoryForActionPlan(actionPlanId);
            this.history = resp.data.data;
            this.currentActionPlan = actionPlanId;
            return this.history;
        } catch (e) {
            appStore.addError(e);
        } finally {
            this.isFetchingHistory = false;
        }
    }
}